"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _constantes = require("./constantes");
var _formFormik = _interopRequireDefault(require("./formik/formFormik"));
var _formTanstack = _interopRequireDefault(require("./tanstack/formTanstack"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Decs = function Decs(_ref) {
  var strings = _ref.strings,
    _ref$obrigatorio = _ref.obrigatorio,
    obrigatorio = _ref$obrigatorio === void 0 ? false : _ref$obrigatorio,
    formExterno = _ref.formExterno,
    _ref$multiplos = _ref.multiplos,
    multiplos = _ref$multiplos === void 0 ? false : _ref$multiplos,
    _ref$tanStackForm = _ref.tanStackForm,
    tanStackForm = _ref$tanStackForm === void 0 ? false : _ref$tanStackForm,
    form = _ref.form,
    field = _ref.field,
    _ref$tipoFormulario = _ref.tipoFormulario,
    tipoFormulario = _ref$tipoFormulario === void 0 ? _constantes.TIPO_FORMULARIO.FORMIK : _ref$tipoFormulario;
  var propsComuns = {
    strings: strings,
    multiplos: multiplos
  };
  switch (tipoFormulario) {
    case _constantes.TIPO_FORMULARIO.TANSTACK:
      return /*#__PURE__*/_react["default"].createElement(_formTanstack["default"], _extends({}, propsComuns, {
        form: form,
        tanStackForm: tanStackForm,
        campo: field
      }));
    case _constantes.TIPO_FORMULARIO.FORMIK:
    default:
      return /*#__PURE__*/_react["default"].createElement(_formFormik["default"], _extends({}, propsComuns, {
        obrigatorio: obrigatorio,
        formExterno: formExterno
      }));
  }
};
var _default = exports["default"] = Decs;